/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { isRightToLeft } from 'js/lib/language';

import { ArrowNextIcon, ArrowPreviousIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/ent-website';

import 'css!./__styles__/Arrows';

// I've isolated this work to a different file because it involves stylus imports.
// I consider this to be technical debt because we are using an old slider because
// there is no CDS slider in place at the moment.

type ArrowProps = {
  behavior: 'previous' | 'next';
};
const styles = {
  arrow: css`
    position: absolute;
    top: -50px;
    left: auto !important;
  `,

  arrowPrev: css`
    right: 32px !important;
  `,

  arrowNext: css`
    right: 0 !important;
  `,
};

function Arrow({ behavior, ...otherProps }: ArrowProps) {
  // The <Carousel> component flips the left/right arrows when the language is RTL.
  // Since we override the arrows, we need to do the flip instead.
  let actualBehavior = behavior;
  const flip = isRightToLeft(_t.getLocale());
  if (flip) {
    actualBehavior = behavior === 'previous' ? 'next' : 'previous';
  }

  const arrowClassName = actualBehavior === 'previous' ? 'arrow-prev' : 'arrow-next';

  return (
    <div {...otherProps}>
      <span
        className={arrowClassName}
        css={[styles.arrow, actualBehavior === 'previous' ? styles.arrowPrev : styles.arrowNext]}
      >
        {actualBehavior === 'previous' ? <ArrowPreviousIcon size="large" /> : <ArrowNextIcon size="large" />}
      </span>
    </div>
  );
}

export default Arrow;
